// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3xpUi","name":"ConsentHeader_name__37Imf","birthday":"ConsentHeader_birthday__4k_rK","skeleton":"ConsentHeader_skeleton__3Cw8f"};